import React, { useEffect } from 'react';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Card from '../../general/card/card.component';
import Typography from '@mui/material/Typography';
import Padding from '../../general/padding/Padding';
import { useLocation } from 'react-router-dom';
import Heading from '../../general/heading/heading.component';
import Header from '../../general/Headers/Header';
import { isLoggedIn } from '../general/sign-in/sign-in.component';

const Landing = ({firstBoxText, lastBoxText, middleBoxText, heading}) => {

    const location = useLocation();
    let currentPath = location.pathname.substring(1); //to get only the current path
    currentPath = currentPath.charAt(currentPath.length - 1)==='/' ? currentPath.substring(0,currentPath.length-1) : currentPath; //sometimes route has extra / at the end, have to trim the same if it exists
    let buttonLink1 = `${currentPath}/studentportal/one`;
    let buttonLink2 = `${currentPath}/facultyportal/one`;
    //Reusing this same component for general sign-up landing page and facultyflow-dashboard
    //Will check the current route and decide the buttonlinks, will have the Box contents passed down as props
    //use this user object to check if someone is signed in
    if((currentPath.substring(currentPath.lastIndexOf('/'))).substring(1)==='faculty' || (currentPath.substring(currentPath.lastIndexOf('/'))).substring(1)==='faculty/')
    {   
        console.log(isLoggedIn)
        if(isLoggedIn)
        {
        buttonLink1 = `${currentPath}/formEligibility`;
        buttonLink2 = `${currentPath}/formPlaced`;
        }
        else
        {
            window.location.replace('../../../notfound');
        }

    }
    return(
    <Grid container justifyContent="center" display="flex">
        <Grid container justifyContent="center">
        <Grid item justifyContent="center" lg={12} md={12}>
        <Header/>
        </Grid>
        </Grid>
        <Grid container justifyContent="center">
        <Grid item justifyContent="center" lg={12} md={12}>
        <br /> <br/> <br/>
        <Heading text={heading}/>
        </Grid>
        </Grid>
        <Grid container justifyContent="center">
            <Grid item  >
                <Card title={firstBoxText} buttonText="Go" buttonLink={buttonLink1}/>
            </Grid>
        
            <Divider orientation="vertical" flexItem sx={{ fontSize: 20, fontFamily:'Montserrat'}}>
            {middleBoxText}
            </Divider>

            <Grid item >
                <Card title={lastBoxText} buttonText="Go" buttonLink={buttonLink2}/>
            </Grid>
        </Grid>
    </Grid>
    )
}

export default Landing;